import { DummyStore } from 'stores';

import { Commission } from '../types/commissions.type';
import { CommissionResponse } from '../types/response.type';

export namespace CommissionStore {
  export const commissions = new DummyStore<CommissionResponse>();
  export const modifyCommission = new DummyStore<Commission.TableRow | null>();
}
